import Vue from "vue"
import router from "./Router.js"
import App from "./App.vue"
import store from "./Js/Store"
import API from "./Api"
import UUID from "vue-uuid"
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import Sortable from "sortablejs"
import "./Js/Mixins/HelperMixin.js"
import "./Style/App.styl"
import "./Style/Components/Components.styl"
import "./Style/Pages/Pages.styl"

Vue.use(require("vue-moment"));
Vue.use(UUID);

Vue.directive("sortable", {
    inserted: function (el, binding) {
        new Sortable(el, binding.value || {})
    }
});

//Vue.config.performance = true;

// Disable logging on localhost
if(window.location.hostname !== "localhost")
{
    Sentry.init({
        dsn: "https://ba973402ae8a46a7b045a8d6d5cd92be@sentry.io/1486211",
        integrations: [new Integrations.Vue({Vue, attachProps: true})],
    });
}

function LoadApp() {
    const app = new Vue({
        el: "#app",
        render: h => h(App),
        router,
        store
    });
}

// Load and set application data if user is validated
API.get("member/IsLoggedIn").then((res) => {

    // true if logged in
    if(!res.data)
        return LoadApp();

    store.dispatch("getMember");
    store.dispatch("getActiveProjects").then(() => {
        LoadApp();
    }).catch((error) =>
        {
            console.log(error);
        }
    )

}).catch((res) => {
    LoadApp();
});


